<template>
  <transition name="slide">
    <v-card v-if="show" class="drawer financial-drawer elevation-7 gray-7--text">
      <employee-list @closeDrawer="closeDrawer" />
    </v-card>
  </transition>
</template>

<script>
import EmployeeList from './EmployeeList'

export default {
  name: 'AccessProfilesDrawer',
  components: {
    EmployeeList
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeDrawer () {
      this.$emit('closeDrawer')
    }
  }
}
</script>
